/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { useTicketConfig } from '../../hooks/ticket';
import { getMatchUrl } from "../../utils/routes";

function MatchRow({ match, highlight, markMatchAsHighlighted }) {
  const { homeTeamName, visitingTeamName, homeTeamAbbrv, status} = match;
  const [ticketConfig] = useTicketConfig(homeTeamAbbrv);

  const ticketUrl = _.get(ticketConfig, 'ticketUrl', '');

  const bgStyle = highlight
    ? 'col-12 px-2 px-sm-4 py-2 data-container__row--transparent-primary data-container__row--has-hover d-flex cursor-pointer'
    : 'col-12 px-2 px-sm-4 py-2 data-container__row d-flex data-container__row--has-hover cursor-pointer';

  const teamNameStyle = 'd-flex align-items-center text-small heading-sm-h5 text-transform-none font-weight-700';

  return (
    <div className={bgStyle} onClick={() => markMatchAsHighlighted(match.id)}>
      <p className={teamNameStyle}>
        {homeTeamName} - {visitingTeamName}
      </p>
      <div className="ml-auto d-flex d-sm-none gap-2 align-items-center justify-content-end flex-grow-1">
        <a className="button button--primary button--small" href={getMatchUrl(match.configSeasonStartYear, match.id, homeTeamName, visitingTeamName)}>
          Inför
        </a>
        {status === 'UPCOMING' && ticketUrl && (
            <a
                className="button button--primary-blue button--small"
                href={ticketUrl}
            >
              Biljett
            </a>
        )}
      </div>
    </div>
  );
}

MatchRow.propTypes = {
  match: PropTypes.shape({
    homeTeamName: PropTypes.string.isRequired,
    visitingTeamName: PropTypes.string.isRequired,
    homeTeamAbbrv: PropTypes.string.isRequired,
  }).isRequired,
  highlight: PropTypes.bool.isRequired,
  markMatchAsHighlighted: PropTypes.func.isRequired,
};

export default MatchRow;
